import { createWebHistory, createRouter } from 'vue-router';
import routes from './routes';
import store from '../state/store';
import { getMenuItems } from '../config/menuItems';

const router = createRouter({
  history: createWebHistory(),
  routes,
  // mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {
  if (store.state.isAuthenticated) {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        if (user?.company?.id) {
          const companySettingsKey = `company_${user.company.id}_settings`;
          const companySettings = user.company.settings || {};

          localStorage.setItem(companySettingsKey, JSON.stringify(companySettings));
        }

        if (!store.state.menuItems || store.state.menuItems.length === 0) {
          try {
            const menuItems = getMenuItems();
            store.commit('SET_MENU_ITEMS', menuItems);
          } catch (menuErr) {
            console.error('Erro ao carregar menu items no router:', menuErr);
          }
        }
      }
    } catch (err) {
      console.error('Erro ao carregar configurações da empresa:', err);
    }
  }

  if (to?.meta?.requiresAuth && !store.state.isAuthenticated) {
    next('/');
  } else {
    next();
  }
});

export default router;
